import { useNavigate } from "react-router-dom";
import { BRAND_LOGO } from "../config/constants";
import { HeroSection, FeaturedSection, AnimeSection, NewsletterSignup } from "../components/sections";
import { SEO } from "../components/SEO";

export default function HomePage({ products }) {
  const navigate = useNavigate();
  
  const categories = [
    {
      title: "Faith Over Everything",
      description: "My faith ain't quiet — it's loud, bold, and unapologetic.",
      link: "/faith",
      color: "cyan",
      icon: "✝"
    },
    {
      title: "Culture Classics",
      description: "We don't forget where we came from. Legends live forever.",
      link: "/hiphop",
      color: "red",
      icon: "🎤"
    },
    {
      title: "Everyday Confidence",
      description: "Every fit hits different when you know who you are.",
      link: "/streetwear",
      color: "cyan",
      icon: "🔥"
    },
    {
      title: "Limited Drops",
      description: "If you know, you know. Once it's gone, it's gone.",
      link: "/sports",
      color: "red",
      icon: "⚡"
    }
  ];
  
  return (
    <div data-testid="home-page">
      <SEO 
        title="Premium Streetwear That Speaks"
        description="Fresh Po'Boy Streetwear - Premium T-Shirts, Hoodies & Sweaties. 10% OFF everything. Faith, Hip Hop, Sports, Anime & more. Shop the culture."
        path="/"
      />
      <HeroSection />
      <FeaturedSection products={products} />
      
      {/* Category Vibes Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-black via-zinc-900/50 to-black">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <span className="text-red-500 text-sm tracking-widest uppercase">Shop By Vibe</span>
            <h2 className="text-white text-4xl sm:text-6xl font-bebas mt-2">Find Your <span className="text-cyan-400">Style</span></h2>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {categories.map((cat) => (
              <div 
                key={cat.link}
                onClick={() => navigate(cat.link)}
                className={`group cursor-pointer p-8 rounded-2xl border transition-all duration-300 hover:-translate-y-2 ${
                  cat.color === 'cyan' 
                    ? 'bg-cyan-400/5 border-cyan-400/20 hover:border-cyan-400/50 hover:bg-cyan-400/10' 
                    : 'bg-red-600/5 border-red-600/20 hover:border-red-600/50 hover:bg-red-600/10'
                }`}
                data-testid={`category-${cat.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="text-4xl mb-4">{cat.icon}</div>
                <h3 className={`font-bebas text-2xl mb-3 ${cat.color === 'cyan' ? 'text-cyan-400' : 'text-red-500'}`}>
                  {cat.title}
                </h3>
                <p className="text-white/60 text-sm leading-relaxed mb-4">
                  {cat.description}
                </p>
                <span className={`text-sm font-semibold ${cat.color === 'cyan' ? 'text-cyan-400' : 'text-red-500'} group-hover:underline`}>
                  Shop Now →
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <AnimeSection products={products} isPage={false} />
      
      {/* Newsletter Signup */}
      <NewsletterSignup />
      
      <section className="py-20 px-4 bg-black">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-red-500 text-sm tracking-widest uppercase">About Us</span>
            <h2 className="text-white text-4xl sm:text-5xl font-bebas mt-2">Born From The Streets</h2>
            <p className="text-white/60 mt-6 leading-relaxed">Fresh Po'Boy Streetwear LLC isn't just a brand—it's a movement. We create premium streetwear that speaks to the culture. T-Shirts, Hoodies & Sweaties.</p>
            <button onClick={() => navigate('/our-story')} className="mt-6 px-6 py-3 border-2 border-cyan-400 text-cyan-400 font-semibold hover:bg-cyan-400 hover:text-black transition-colors" data-testid="read-story-btn">
              Read Our Story
            </button>
          </div>
          <div className="aspect-square rounded-lg overflow-hidden border-2 border-red-600/30">
            <img src={BRAND_LOGO} alt="Fresh Po'Boy Streetwear" className="w-full h-full object-contain bg-black p-8" />
          </div>
        </div>
      </section>
      
      <footer className="py-8 px-4 bg-zinc-900 border-t border-red-600/30">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <img src={BRAND_LOGO} alt="Fresh Po'Boy" className="h-12 w-auto" />
          <div className="flex items-center gap-6">
            <a href="/unsubscribe" className="text-white/30 hover:text-white/50 text-xs transition-colors" data-testid="unsubscribe-footer-link">Unsubscribe</a>
            <a href="https://app.emergent.sh/?utm_source=emergent-badge" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white/40 hover:text-white/60">
              <img src="https://avatars.githubusercontent.com/in/1201222?s=120&u=2686cf91179bbafbc7a71bfbc43004cf9ae1acea&v=4" alt="Emergent" className="w-5 h-5 rounded" />
              Made with Emergent
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
